import z from "zod";
import { preCheckExistWrapper } from "@/lib/utils/func";
import { scholarshipTitleApi } from "@/lib/api/scholarship-title";

export type tScholarshipTitleSchema = z.infer<typeof scholarshipTitleSchema>;

export const scholarshipTitleSchema = z.object({
    id: z.string().optional(),
    titleName: z.string().trim().nonempty({ message: "Bắt buộc nhập" }).max(255, { message: "Tên danh hiệu không được vượt quá 255 ký tự" }),
    currentTitleName: z.string().optional(),
    notes: z.string().max(500, { message: "Mô tả không được vượt quá 500 ký tự" }).optional(),
}).superRefine(async (data, ctx) => {

    const { titleName, currentTitleName } = data;

    await preCheckExistWrapper<string>(currentTitleName, titleName, async (value) => {
        const exists = await scholarshipTitleApi.checkExist({ searchValue: value });
        if (exists) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Tên danh hiệu đã tồn tại",
                path: ["titleName"],
            });
            return;
        }
    });

});